import { Avatar, Box, IconButton, TableBody, TableRow, Typography } from '@mui/material'
import dayjs from 'dayjs'

function ChangesHistory() {
	return (
		<Box
			display='flex'
			flexDirection='column'
			justifyContent='flex-start'
			sx={{ marginBlockEnd: '0.5rem' }}
		>
			<Typography
				component='span'
				variant='h6'
				sx={{ marginBlock: '1rem', marginInline: '0.5rem' }}
			>
				Histórico de Alterações às Preferências de Empresa
			</Typography>
			<TableBody id='tableBody'>
				<TableRow
					id='tableRow'
					hover={true}
					selected={false}
					sx={{
						cursor: 'pointer',
						backgroundColor: 'none',
						borderBlockEnd: '1px solid #0000001F',
						width: '100%',
						display: 'flex',
					}}
				>
					<Box sx={{ display: 'flex', width: '100%' }}>
						<Avatar
							sx={{
								borderRadius: '100%',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
								bgcolor: 'lightgrey 50% / cover no-repeat',
								width: 32,
								height: 32,
								fontSize: '20px',
								fontWeight: 400,
								lineHeight: 1,
								marginInlineEnd: '0.5rem',
							}}
						/>
						<Typography
							variant='body1'
							noWrap
							component='div'
							sx={{ color: 'black' }}
						>
							Name
						</Typography>
						<Typography
							variant='h6'
							noWrap
							component='div'
							sx={{ color: 'darkgray', marginInline: '0.5rem' }}
						>
							|
						</Typography>
						<Typography
							variant='body1'
							noWrap
							component='div'
							sx={{ color: 'black' }}
						>
							Company
						</Typography>
					</Box>
					<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Typography variant='body1'>{dayjs().format('HH:mm')}</Typography>
						<Typography
							variant='h6'
							noWrap
							component='div'
							sx={{ color: 'darkgray', marginInline: '0.5rem' }}
						>
							|
						</Typography>
						<Typography variant='body1'>{dayjs().format('DD/MM/YYYY')}</Typography>
					</Box>
				</TableRow>
			</TableBody>
		</Box>
	)
}

export default ChangesHistory
